import React, { useState } from "react";
import Button from "../../../../components/common/button";
import { CustomOfferSvg, EditSvg, LeftArrowSvg } from "../../../../icons";
import { Link, useParams } from "react-router-dom";
import useGetOfferTemplatesQuery from "../../../../hooks/use-get-offer-templates";
import Spinner from "../../../../components/common/Spinner";
import Modal from "../../../../components/common/Modal";
import { IOfferTemplate } from "../../../../utils/types";
import CreateOfferTemplate from "../templates/create-offer-template";

const OfferTemplates: React.FC = () => {
  const params = useParams();
  const { data: offerTemplatesData, isLoading: offerTemplatesDataLoading } =
    useGetOfferTemplatesQuery();

  const [editOfferTemplateModal, setEditOfferTemplateModal] = useState<{
    open: boolean;
    data: IOfferTemplate | null;
  }>({
    open: false,
    data: null,
  });

  const closeEditOfferTemplateModal = () => {
    setEditOfferTemplateModal({ open: false, data: null });
  };

  const openEditOfferTemplateModal = (template: IOfferTemplate) => {
    setEditOfferTemplateModal({ open: true, data: { ...template } });
  };

  return (
    <div>
      <div className="">
        <div className="flex gap-2 items-center">
          <Link
            to={`${process.env.PUBLIC_URL}/shmv/tv-app/my-stay/offers-and-packages`}
          >
            <LeftArrowSvg />
          </Link>
          <h3 className="text-[22px] font-normal text-[#1E2F65]">
            Offers Management
          </h3>
        </div>
        <h2 className="text-[14px] mt-9 font-normal text-[#1E2F65]">
          Create an offer
        </h2>
        <h3 className="text-[12px] font-normal text-[#1E2F65] mt-[22px]">
          Select Template
        </h3>
      </div>
      {offerTemplatesDataLoading ? (
        <div className="w-full flex items-center justify-center min-h-32">
          <Spinner />
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-5 gap-5 mt-6 transition-all duration-300">
          {offerTemplatesData?.result?.data?.map((template) => (
            <div
              key={template._id}
              className="border shadow-lg hover:shadow-lg transition duration-300 flex flex-col items-stretch"
            >
              <div className="h-52 w-full flex items-center justify-center">
                <img
                  src={template.tvSetupImage}
                  alt={template.name}
                  className="max-h-full object-cover"
                />
              </div>
              <div className="p-4 flex flex-col flex-grow">
                <h5 className="text-[12px] font-semibold">{template.name}</h5>
                <p className="text-[10px] text-gray-500 my-2">
                  {template.description}
                </p>
                <div className="flex items-center gap-2">
                  <Link
                    to={`/${params.hotelcode}/tv-app/my-stay/offers-and-packages/create?templateId=${template._id}`}
                    className="mt-auto w-full"
                  >
                    <Button className="w-full text-black bg-white border border-black text-[12px] font-medium py-2 hover:bg-black hover:text-white transition">
                      Select
                    </Button>
                  </Link>
                  <div
                    className="h-full w-8 flex items-center justify-center text-white bg-black border border-black text-[12px] font-medium hover:bg-white hover:text-black transition cursor-pointer"
                    onClick={() => openEditOfferTemplateModal(template)}
                  >
                    <EditSvg />
                  </div>
                </div>
              </div>
            </div>
          ))}
          <Link
            to={`/${params.hotelcode}/tv-app/my-stay/offers-and-packages/create`}
            className="flex flex-col justify-center items-center border-gray-300 p-6 rounded-lg bg-gray-50 shadow-sm hover:shadow-lg transition duration-300"
          >
            <div className="bg-[#D9D9D9] w-[40px] h-[40px] flex justify-center items-center rounded-full ">
              <CustomOfferSvg />
            </div>
            <h5 className="text-[12px] mt-4 font-semibold ">
              Create a Custom Offer
            </h5>
          </Link>
        </div>
      )}

      <Modal
        isOpen={editOfferTemplateModal.open}
        closeModal={closeEditOfferTemplateModal}
        title={"Edit Offer Template"}
        headerClassName="px-6"
        modelContentClassName="mt-1"
        className="w-[60%] mx-auto rounded-lg bg-white shadow-lg p-0 pb-6"
      >
        <div className="max-h-[75vh] overflow-y-auto p-6 pt-0">
          <CreateOfferTemplate
            offer={editOfferTemplateModal?.data!}
            isEditOfferTemplate
            onSuccess={() => closeEditOfferTemplateModal()}
          />
        </div>
      </Modal>
    </div>
  );
};

export default OfferTemplates;
